











//
// WARNING
// This file is auto-generated by Queries.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Queries.tst.
//

import { Type, Transform } from "class-transformer";
import { CancelToken } from 'axios'
import * as moment from 'moment'
import * as qrs from '@/modules/qrs'

import {
    Query,
    IPaginatedQuery, SearchDirection, ProtectedMemory,
    QueryExecutor, PaginatedQueryExecutor
} from '@/modules/qrs'

import {
    IOrderableQuery, IOrderByDescriptor, IOrderBySelectorFn, OrderByConfig, IOrderableProperties,
    OrderableQueryExecutor, OrderablePaginatedQueryExecutor
} from '@/modules/qrs/extensions/orderable'


    

    @Query('BinIdValuesQuery')
    
    export class BinIdValuesQuery  {
        constructor( binId: number ) {
            
                this.binId = binId;
            
        }

        
            
            public binId: number;
        

        

        

        
            /**
            * Returns an instance of a simple QueryExecutor for this query.
            */
            public static getExecutor( query?: BinIdValuesQuery ) {
                return new QueryExecutor<BinIdValuesQuery, BinIdValuesResult>(BinIdValuesResult, query);
            }

            

            
        
    }

    

    
        /**
        * The result model for BinIdValuesQuery.
        */
        export class BinIdValuesResult {
            
                
                 binId: number;
            
                
                 valueIndex: number;
            
                
                 bin: number;
            
                
                 vss: number;
            
                
                 vsi: number;
            
                
                 showGraph: boolean;
            
        }
    

    /**
    * Extraneous types
    */
    export namespace BinIdValuesQuery.ExtraneousTypes {
        

        
    }

